import { render } from "./ActionWait.vue?vue&type=template&id=df7cdf0a"
import script from "./ActionWait.vue?vue&type=script&lang=ts"
export * from "./ActionWait.vue?vue&type=script&lang=ts"
script.render = render

export default script